import React from 'react'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import {
  formatPrimaryMetalType,
  formatPrimaryDiamondShape,
  formatBasketType,
  formatAdditionalDiamond,
  formatHalo,
  formatHaloWidth,
  formatProngStyle,
  formatProngNumber,
  formatHandEngraving,
  formatSpecialFinish
} from './field-formatters'

const StudEarringDetails = props => (
  <Grid>
    <GridItem col='1/4'>
      <DetailsItem title='Primary Metal' value={formatPrimaryMetalType(props.data)} />
      <DetailsItem title='Halo' value={formatHalo(props.data)} />
      <DetailsItem title='Hand Engraving' value={formatHandEngraving(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Diamond Shape' value={formatPrimaryDiamondShape(props.data)} />
      <DetailsItem title='Row Width' value={formatHaloWidth(props.data)} />
      <DetailsItem title='Special Finish' value={formatSpecialFinish(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Basket Type' value={formatBasketType(props.data)} />
      <DetailsItem title='Prong Style' value={formatProngStyle(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Additional Diamond(s)' value={formatAdditionalDiamond(props.data)} />
      <DetailsItem title='Prong Number' value={formatProngNumber(props.data)} />
    </GridItem>
  </Grid>
)

export default StudEarringDetails



// WEBPACK FOOTER //
// ./src/components/jewelry-details/stud-earring-details.js